import "./styles.css";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { App } from "./App.js";
import { AuthProvider } from "./AuthProvider.js";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // Case and document data is sensitive and changes under the client's feet
      // as professionals work. Refetch rather than show a stale status — a
      // confidently wrong "DELIVERED" is worse than a spinner.
      staleTime: 0,
      retry: 1,
    },
  },
});

const root = document.getElementById("root");
if (!root) throw new Error("#root is missing from index.html");

createRoot(root).render(
  <StrictMode>
    <AuthProvider>
      <QueryClientProvider client={queryClient}>
        <App />
      </QueryClientProvider>
    </AuthProvider>
  </StrictMode>,
);
